"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const usePenOptions_1 = require("../../hooks/usePenOptions");
const providers_1 = require("../../providers");
const colors_1 = require("../../utils/colors");
const DrawOptions_1 = __importDefault(require("../DrawOptions"));
const PEN2D_COLORS = [
    ui_1.colorPalette.black,
    ui_1.colorPalette.vividCerulean,
    ui_1.colorPalette.lightSeaGreen,
    ui_1.colorPalette.halloweenOrange,
    ui_1.colorPalette.pinkBite,
    ui_1.colorPalette.kenMastersRed,
];
const PEN2D_SIZES = [
    bridge_schema_1.PenSizeIndex.XLarge,
    bridge_schema_1.PenSizeIndex.Large,
    bridge_schema_1.PenSizeIndex.Medium,
    bridge_schema_1.PenSizeIndex.Small,
];
function PenOptionsPanel({ className, initialType, initialColor, initialSize, initialOpacity, }) {
    const { color, size, opacity } = (0, usePenOptions_1.usePenOptions)();
    const [isOverlayVisible, setOverlayVisible] = (0, react_1.useState)(false);
    const [selectedColor, setSelectedColor] = (0, react_1.useState)(initialColor || color);
    const [selectedSize, setSelectedSize] = (0, react_1.useState)(initialSize || size);
    const [selectedOpacity, setSelectedOpacity] = (0, react_1.useState)(initialOpacity || opacity);
    const toolsService = (0, providers_1.useToolsService)();
    const penManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getPenToolManager();
    (0, react_1.useEffect)(() => {
        var _a;
        penManager === null || penManager === void 0 ? void 0 : penManager.updatePenOptions({
            color: (_a = initialColor === null || initialColor === void 0 ? void 0 : initialColor.toString()) !== null && _a !== void 0 ? _a : '229,51,157',
            size: initialSize,
            opacity: initialOpacity,
            optionType: -1,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onChangeColor = (value) => {
        const { r, g, b } = (0, colors_1.hexToRgbComponents)(value);
        const rgbColorArray = [r, g, b];
        const rgbColorString = `${r},${g},${b}`;
        penManager === null || penManager === void 0 ? void 0 : penManager.updatePenOptions({
            optionType: 4,
            color: rgbColorArray.toString(),
            type: initialType || bridge_schema_1.ToolType.Pen2D,
        });
        setSelectedColor(rgbColorString);
    };
    const onChangeSize = (value) => {
        penManager === null || penManager === void 0 ? void 0 : penManager.updatePenOptions({
            optionType: 1,
            size: value,
            type: initialType || bridge_schema_1.ToolType.Pen2D,
        });
        setSelectedSize(value);
    };
    const onChangeOpacity = (value) => {
        penManager === null || penManager === void 0 ? void 0 : penManager.updatePenOptions({
            optionType: 3,
            opacity: value,
        });
        setSelectedOpacity(value);
    };
    const onToggle = (isActive) => {
        setOverlayVisible(isActive);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Overlay, { shown: isOverlayVisible, zIndex: 0, "data-e2e": 'PenOptionsPanel_Overlay' }), (0, jsx_runtime_1.jsx)(DrawOptions_1.default, { className: className, colors: PEN2D_COLORS, sizes: PEN2D_SIZES, color: (0, colors_1.rgbComponentsToHex)(selectedColor), size: selectedSize, initialOpacity: selectedOpacity, withOpacity: true, onChangeColor: onChangeColor, onChangeSize: onChangeSize, onChangeOpacity: onChangeOpacity, onToggle: onToggle, "data-e2e": 'PenOptionsPanel_DrawOptionsPanel' })] }));
}
exports.default = PenOptionsPanel;
